<div class="page-head">
  <div>
    <p class="eyebrow">งานอนุมัติ</p>
    <h1>อนุมัติค่าคอมมิชชั่น</h1>
    <p>ตรวจสอบและพิจารณาค่าคอมมิชชั่นจาก Booking และ Tour</p>
  </div>
</div>

<section class="rounded-xl border border-slate-200 bg-white shadow-sm">
  <p-table
    #commissionApprovalTable
    [value]="rows()"
    dataKey="id"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [globalFilterFields]="[
      'code',
      'bookingCode',
      'customerName',
      'tripName',
      'saleName',
      'sourceType',
      'status'
    ]"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="แสดง {first} ถึง {last} จาก {totalRecords} รายการ"
    [tableStyle]="{ 'min-width': '1480px' }"
  >
    <ng-template #caption>
      <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <label class="relative block w-full max-w-md"
        ><lucide-icon
          name="Search"
          [size]="17"
          class="pointer-events-none absolute top-1/2 left-2 z-10 -translate-y-1/2 text-slate-400" /><input
          pInputText
          #query
          class="h-11 w-full pr-3 text-sm placeholder:text-slate-400"
          style="padding-left: 2.75rem; border-radius: 0.5rem"
          placeholder="ค้นหาค่าคอมมิชชั่น, Booking, Tour หรือลูกค้า"
          (input)="commissionApprovalTable.filterGlobal(query.value, 'contains')" /></label>
      <app-refresh-button
        class="self-end sm:self-auto"
        label="รีเฟรชรายการอนุมัติค่าคอมมิชชั่น"
        [loading]="isLoadingCommissions()"
        (refresh)="loadCommissions()"
      />
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th class="w-14 text-center text-xs whitespace-nowrap">ลำดับ</th>
        <th pSortableColumn="code" class="min-w-52 text-xs whitespace-nowrap">
          คำขอคอมมิชชั่น <p-sortIcon field="code" />
        </th>
        <th pSortableColumn="bookingCode" class="min-w-72 text-xs whitespace-nowrap">
          Booking / Tour <p-sortIcon field="bookingCode" />
        </th>
        <th pSortableColumn="bookingAmount" class="w-40 text-right text-xs whitespace-nowrap">
          ยอดอ้างอิง <p-sortIcon field="bookingAmount" />
        </th>
        <th class="min-w-60 text-xs whitespace-nowrap">รายละเอียดคอมมิชชั่น</th>
        <th pSortableColumn="commissionAmount" class="w-40 text-right text-xs whitespace-nowrap">
          ยอดเบิก <p-sortIcon field="commissionAmount" />
        </th>
        <th class="w-36 text-right text-xs whitespace-nowrap">หักยอดค้าง</th>
        <th class="w-40 text-right text-xs whitespace-nowrap">ยอดรับสุทธิ</th>
        <th pSortableColumn="status" class="w-36 text-xs whitespace-nowrap">
          สถานะ <p-sortIcon field="status" />
        </th>
        <th class="w-28 text-right text-xs whitespace-nowrap">พิจารณา</th>
      </tr>
    </ng-template>
    <ng-template #body let-row let-rowIndex="rowIndex">
      <tr class="transition even:bg-slate-50/40 hover:bg-sky-50/60">
        <td class="py-3.5 text-center text-[13px] text-slate-400 tabular-nums align-top">
          {{ rowIndex + 1 }}
        </td>
        <td class="py-3.5 text-[13px] align-top">
          <p class="m-0 text-sm font-semibold whitespace-nowrap text-sky-700">{{ row.code }}</p>
          <p class="mt-1 mb-0 text-xs font-semibold text-violet-700">
            {{ row.sourceType === 'TOUR' ? 'ค่าคอมระดับ Tour' : 'ค่าคอมระดับ Booking' }}
          </p>
          <p class="mt-1 mb-0 text-xs text-slate-500">ผู้รับค่าคอม: {{ row.saleName || '—' }}</p>
          <p class="mt-1 mb-0 text-xs whitespace-nowrap text-slate-500">
            ส่งเมื่อ {{ row.submittedAt | date: 'dd MMM yyyy, HH:mm' }}
          </p>
        </td>
        <td class="py-3.5 text-[13px] align-top">
          <p class="m-0 text-sm font-semibold whitespace-nowrap text-slate-800">{{ row.bookingCode }}</p>
          <p class="mt-1 mb-0 max-w-72 text-xs leading-5 text-slate-500">
            {{ row.tripName || 'ไม่ระบุโปรแกรมทัวร์' }}
          </p>
          <p class="mt-1 mb-0 text-xs text-slate-500">
            {{ row.sourceType === 'TOUR' ? 'รายการจาก Tour' : 'ลูกค้า: ' + (row.customerName || '—') }}
          </p>
        </td>
        <td class="py-3.5 text-right text-[13px] tabular-nums align-top">
          <p class="m-0 text-sm font-semibold whitespace-nowrap text-slate-800">
            {{ row.bookingAmount | number: '1.2-2' }} บาท
          </p>
        </td>
        <td class="py-3.5 text-[13px] align-top">
          <div class="grid gap-1 text-xs text-slate-500">
            <div class="flex items-center justify-between gap-4">
              <span>จำนวนคน</span>
              <span class="font-medium whitespace-nowrap text-slate-700 tabular-nums">
                {{ row.travelerCount }} คน
              </span>
            </div>
            @if (row.sourceType === 'TOUR') {
              <div class="flex items-center justify-between gap-4">
                <span>อัตราผู้ดูแล</span>
                <span class="font-medium whitespace-nowrap text-slate-700 tabular-nums">
                  {{ row.commissionRate | number: '1.2-2' }}%
                </span>
              </div>
            } @else {
              <div class="flex items-center justify-between gap-4">
                <span>คอมพนักงานขาย</span>
                <span class="font-medium whitespace-nowrap text-slate-700 tabular-nums">
                  {{ row.saleCommission | number: '1.2-2' }} บาท
                </span>
              </div>
              <div class="flex items-center justify-between gap-4">
                <span>คอมพิเศษ</span>
                <span class="font-medium whitespace-nowrap text-slate-700 tabular-nums">
                  {{ row.specialCommission | number: '1.2-2' }} บาท
                </span>
              </div>
            }
          </div>
        </td>
        <td class="py-3.5 text-right text-sm font-semibold whitespace-nowrap text-emerald-700 tabular-nums align-top">
          {{ row.commissionAmount | number: '1.2-2' }} บาท
        </td>
        <td class="py-3.5 text-right text-sm whitespace-nowrap tabular-nums align-top">
          @if (row.recoveryDeduction > 0) {
            <span class="font-semibold text-red-600">-{{ row.recoveryDeduction | number: '1.2-2' }} บาท</span>
          } @else {
            <span class="text-slate-400">—</span>
          }
        </td>
        <td class="py-3.5 text-right text-sm font-bold whitespace-nowrap text-emerald-700 tabular-nums align-top">
          {{ row.netPaymentAmount | number: '1.2-2' }} บาท
        </td>
        <td class="py-3.5 align-top"><app-status-badge [status]="row.status" /></td>
        <td class="py-3.5 align-top">
          <div class="flex justify-end gap-1.5">
            @if (row.attachmentUrl) {
              <button
                type="button"
                class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white p-0 text-slate-600 hover:bg-slate-50"
                title="เปิดเอกสารแนบ"
                (click)="openAttachment(row.attachmentUrl)"
              >
                <lucide-icon name="FileText" [size]="15" />
              </button>
            }
            <button
              type="button"
              class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white p-0 text-slate-600 hover:bg-slate-50"
              title="ดูรายละเอียดและพิจารณา"
              (click)="open(row)"
            >
              <lucide-icon name="Eye" [size]="15" />
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage
      ><tr>
        <td colspan="10">
          <div class="empty">
            <b><lucide-icon name="BadgePercent" [size]="22" /></b>
            <h3>ไม่มีค่าคอมมิชชั่น รออนุมัติ</h3>
            <p>รายการใหม่จะแสดงที่นี่</p>
          </div>
        </td>
      </tr></ng-template
    >
  </p-table>
</section>
@if (selected(); as commission) {
  <div
    class="fixed inset-0 z-[200] grid place-items-center overflow-y-auto bg-slate-950/45 p-4 backdrop-blur-[2px]"
    (click)="close()"
  >
    <section
      class="my-auto w-full max-w-4xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl"
      role="dialog"
      aria-modal="true"
      (click)="$event.stopPropagation()"
    >
      <div class="flex items-start justify-between border-b border-slate-200 px-5 py-5 sm:px-6">
        <div>
          <p class="mb-1 text-xs font-semibold tracking-wider text-sky-600 uppercase">
            {{ commission.code }}
          </p>
          <h2 class="m-0 text-xl font-bold text-slate-800">รายละเอียดค่าคอมมิชชั่น</h2>
          <div class="mt-2"><app-status-badge [status]="commission.status" /></div>
        </div>
        <button
          type="button"
          class="tw-button inline-flex size-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
          (click)="close()"
        >
          <lucide-icon name="X" [size]="19" />
        </button>
      </div>
      <div class="max-h-[68vh] overflow-y-auto p-5 sm:p-6">
        @if (commission.sourceType === 'BOOKING') {
        <section>
          <h3 class="m-0 text-base font-bold text-slate-800">ข้อมูล Booking</h3>
          <dl
            class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-3"
          >
            <div>
              <dt class="text-xs font-semibold text-slate-500">เลขที่ Booking</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ commission.bookingCode }}</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">ลูกค้า</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ commission.customerName }}</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">โปรแกรมทัวร์</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ commission.tripName }}</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">วันเดินทาง</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">
                {{ commission.travelDate | date: 'dd MMM yyyy' }}
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">จำนวนผู้เดินทาง</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">
                {{ commission.travelerCount | number }} คน
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">ยอด Booking</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">
                {{ commission.bookingAmount | number: '1.2-2' }} บาท
              </dd>
            </div>
          </dl>
        </section>
        }
        @if (commission.tour; as tour) {
          <section class="mt-6">
            <h3 class="m-0 text-base font-bold text-slate-800">รายละเอียดทัวร์</h3>
            <dl
              class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-3"
            >
              <div>
                <dt class="text-xs font-semibold text-slate-500">เลขที่ทัวร์</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.tourNo }}</dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">รหัสทัวร์</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.tourCode }}</dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">ประเทศ</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.country }}</dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">ประเภททัวร์</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">
                  {{ tour.tourType === 'JOIN_TOUR' ? 'จอยทัวร์' : 'กรุ๊ปทัวร์' }}
                </dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">วันเดินทาง</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">
                  {{ tour.travelDate | date: 'dd MMM yyyy' }}
                </dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">วันเดินทางกลับ</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">
                  {{ tour.returnDate ? (tour.returnDate | date: 'dd MMM yyyy') : '-' }}
                </dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">ราคาทัวร์ต่อคน</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">
                  {{ tour.tourPrice | number: '1.2-2' }} บาท
                </dd>
              </div>
            </dl>
          </section>
        }
        @if (!commission.tour) {
          <section class="mt-6">
            <h3 class="m-0 text-base font-bold text-slate-800">ใบสั่งซื้อ</h3>
            <div class="mt-4 rounded-xl border border-slate-200 bg-slate-50 p-4">
              @if (commission.purchaseOrderUrl) {
                <button
                  type="button"
                  class="inline-flex items-center gap-2 text-sm font-semibold text-sky-700 hover:text-sky-900"
                  (click)="openAttachment(commission.purchaseOrderUrl)"
                >
                  <lucide-icon name="FileText" [size]="16" /> เปิดไฟล์ใบสั่งซื้อ
                  <lucide-icon name="ExternalLink" [size]="15" />
                </button>
              } @else {
                <p class="m-0 text-sm text-slate-500">ยังไม่มีไฟล์ใบสั่งซื้อ</p>
              }
            </div>
          </section>
        }
        <section class="mt-6">
          <h3 class="m-0 text-base font-bold text-slate-800">รายการค่าคอมมิชชั่น</h3>
          <dl
            class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-3"
          >
            <div>
              <dt class="text-xs font-semibold text-slate-500">เลขที่ค่าคอมมิชชั่น</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ commission.code }}</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">ผู้รับค่าคอมมิชชั่น</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ commission.saleName }}</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">วันที่ส่ง</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">
                {{ commission.submittedAt | date: 'dd MMM yyyy' }}
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">ยอดค่าคอมมิชชั่น</dt>
              <dd class="mt-1 mb-0 font-semibold text-emerald-700">
                {{ commission.commissionAmount | number: '1.2-2' }} บาท
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">ยอดที่จะหักจากยอดค้าง</dt>
              <dd class="mt-1 mb-0 font-semibold text-red-600">
                -{{ commission.recoveryDeduction | number: '1.2-2' }} บาท
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">ยอดรับสุทธิ (โดยประมาณ)</dt>
              <dd class="mt-1 mb-0 font-bold text-emerald-700">
                {{ commission.netPaymentAmount | number: '1.2-2' }} บาท
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">จำนวนคน</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">
                {{ commission.travelerCount }} คน
              </dd>
            </div>
            @if (commission.sourceType === 'TOUR') {
              <div>
                <dt class="text-xs font-semibold text-slate-500">อัตราคอมมิชชั่นผู้ดูแล</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">
                  {{ commission.commissionRate | number: '1.2-2' }}%
                </dd>
              </div>
            } @else {
              <div>
                <dt class="text-xs font-semibold text-slate-500">คอมพนักงานขาย (ยอดรวม)</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">
                  {{ commission.saleCommission | number: '1.2-2' }} บาท
                </dd>
                <dd class="mt-1 mb-0 text-xs text-slate-500">
                  {{
                    commissionPerPerson(commission.saleCommission, commission.travelerCount)
                      | number: '1.2-2'
                  }}
                  บาท/คน
                </dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">คอมพิเศษ (ยอดรวม)</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">
                  {{ commission.specialCommission | number: '1.2-2' }} บาท
                </dd>
                <dd class="mt-1 mb-0 text-xs text-slate-500">
                  {{
                    commissionPerPerson(commission.specialCommission, commission.travelerCount)
                      | number: '1.2-2'
                  }}
                  บาท/คน
                </dd>
              </div>
            }
            <div class="sm:col-span-2 lg:col-span-3">
              <dt class="text-xs font-semibold text-slate-500">ไฟล์แนบ</dt>
              <dd class="mt-1 mb-0 font-semibold text-sky-700">
                @if (commission.attachmentUrl) {
                  <button
                    type="button"
                    class="inline-flex items-center gap-1.5 text-sky-700 decoration-sky-300 hover:text-sky-900"
                    title="ดูเอกสารแนบในแท็บใหม่"
                    (click)="openAttachment(commission.attachmentUrl)"
                  >
                    ดูเอกสารแนบ
                    <lucide-icon name="ExternalLink" [size]="15" />
                  </button>
                } @else {
                  <span class="text-slate-400">-</span>
                }
              </dd>
            </div>
          </dl>
        </section>
      </div>
      <div
        class="flex flex-col-reverse gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4 sm:flex-row sm:justify-end sm:px-6"
      >
        <button
          type="button"
          class="tw-button h-11 rounded-xl border border-slate-300 bg-white px-5 text-[15px] font-semibold text-slate-700 hover:bg-slate-100"
          (click)="close()"
        >
          ปิด
        </button>
        @if (commission.status === 'SUPERVISOR_REVIEW') {
          <button
            type="button"
            class="tw-button inline-flex h-11 items-center gap-2 rounded-xl border border-red-200 bg-white px-5 text-[15px] font-semibold text-red-600 hover:bg-red-50"
            (click)="reject(commission)"
          >
            <lucide-icon name="X" [size]="17" /> ไม่อนุมัติ</button
          ><button
            type="button"
            class="tw-button inline-flex h-11 items-center gap-2 rounded-xl bg-emerald-600 px-5 text-[15px] font-semibold text-white hover:bg-emerald-700"
            (click)="approve(commission)"
          >
            <lucide-icon name="Check" [size]="17" /> อนุมัติ
          </button>
        }
      </div>
    </section>
  </div>
}
